import { ScoreDataByEntity } from "../components/Table/types";

/**
 * Returns true when the prompt table has at least one score cell for the model (any brand column).
 */
export function modelHasPromptTableScore(
  promptScores: ScoreDataByEntity | null | undefined,
  modelId: string | number,
): boolean {
  if (!promptScores) {
    return false;
  }

  const modelKey = String(modelId);

  return Object.values(promptScores).some(
    (brandScores) => brandScores?.[modelKey] != null,
  );
}
